import type {
  EndCustomer,
  ReferencePoint,
  RouteCalculationResponse,
} from "@/interfaces";
import type React from "react";
import MapTileLayers from "@/components/Map/MapTileLayers";
import { MapContainer } from "react-leaflet";
import FullscreenControl from "./FullscreenControl";
import InteractiveMapContent from "./InteractiveMapContent";
import MapBoundsFitter from "./MapBoundsFitter";

interface InteractiveRouteMapProps {
  customers: EndCustomer[];
  referencePoints: ReferencePoint[];
  selectedCustomers: number[];
  selectedReferencePoint?: number;
  onCustomerSelect: (customerId: number) => void;
  onReferencePointSelect: (referencePointId: number) => void;
  routeData?: RouteCalculationResponse | null;
}

const InteractiveRouteMap: React.FC<InteractiveRouteMapProps> = ({
  customers,
  referencePoints,
  selectedCustomers,
  selectedReferencePoint,
  onCustomerSelect,
  onReferencePointSelect,
  routeData,
}) => {
  return (
    <div className="w-full h-96 rounded-lg overflow-hidden border-2 border-gray-200 dark:border-gray-700 shadow-lg">
      <MapContainer
        center={[-11.59293, -49.597924]}
        zoom={4}
        className="w-full h-full"
        zoomControl={true}
        attributionControl={true}
      >
        <MapTileLayers osmLabel="Detalhado" showMapbox={false} />

        <FullscreenControl />
        <MapBoundsFitter
          customers={customers}
          referencePoints={referencePoints}
          selectedCustomers={selectedCustomers}
          selectedReferencePoint={selectedReferencePoint}
        />
        <InteractiveMapContent
          customers={customers}
          referencePoints={referencePoints}
          selectedCustomers={selectedCustomers}
          selectedReferencePoint={selectedReferencePoint}
          onCustomerSelect={onCustomerSelect}
          onReferencePointSelect={onReferencePointSelect}
          routeData={routeData}
        />
      </MapContainer>
    </div>
  );
};

export default InteractiveRouteMap;
